import type { AITTheme } from '@this/shared/ui/theme';

export function getStyles(theme: AITTheme) {
  const brandPrimary = theme.tokens.colors.brand.primary;
  const brandBackground = theme.tokens.colors.brand.background;
  const textPrimary = theme.tokens.colors.text.primary;
  const textSecondary = theme.tokens.colors.text.description;

  return {
    pageLayout: {
      width: '100%',
      minWidth: 0,
      boxSizing: 'border-box' as const
    } as const,
    pageHeader: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      justifyContent: 'space-between' as const,
      gap: '16px',
      padding: '20px',
      flexWrap: 'wrap' as const
    } as const,
    pageTitle: {
      margin: 0,
      fontSize: '18px',
      fontWeight: 700,
      color: textPrimary
    } as const,
    contentIn: {
      width: '100%',
      minWidth: 0,
      padding: '0 20px 20px',
      boxSizing: 'border-box' as const
    } as const,
    addButton: {
      width: '200px'
    } as const,
    listCard: {
      border: '1px solid #D3D7DB',
      borderRadius: '8px',
      backgroundColor: theme.tokens.colors.common.white,
      overflow: 'hidden' as const
    } as const,
    listRow: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      gap: '16px',
      padding: '16px 20px',
      borderBottom: '1px solid #EEF0F2',
      flexWrap: 'wrap' as const
    } as const,
    listRowLast: {
      borderBottom: 'none'
    } as const,
    pdfIcon: {
      width: '40px',
      height: '40px',
      borderRadius: '4px',
      backgroundColor: brandBackground,
      color: brandPrimary,
      display: 'flex' as const,
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      fontSize: '12px',
      fontWeight: 700,
      flexShrink: 0,
      lineHeight: 1
    } as const,
    rowMain: {
      flex: '1 1 200px',
      minWidth: 0
    } as const,
    rowName: {
      fontSize: '14px',
      fontWeight: 700,
      color: textPrimary,
      lineHeight: 1.5,
      wordBreak: 'break-word' as const
    } as const,
    rowActions: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      gap: '12px',
      flexWrap: 'wrap' as const,
      marginLeft: 'auto' as const
    } as const,
    viewLink: {
      display: 'inline-flex' as const,
      alignItems: 'center' as const,
      gap: '4px',
      fontSize: '14px',
      fontWeight: 500,
      textDecoration: 'underline',
      textUnderlineOffset: '2px'
    } as const,
    viewLinkIcon: {
      width: '16px',
      height: '16px'
    } as const,
    tableActionButton: {
      height: '32px',
      minHeight: '32px',
      minWidth: '64px',
      padding: '3px 10px',
      boxSizing: 'border-box' as const,
      lineHeight: 1.5,
      fontSize: '0.7544642857142857rem',
      boxShadow: 'none'
    } as const,
    emptyMessage: {
      padding: '24px 20px',
      fontSize: '14px',
      color: textSecondary,
      textAlign: 'center' as const
    } as const
  };
}

export type ManualsStyles = ReturnType<typeof getStyles>;
